export const mockTopBannerResponse = {
  alertType: 'BannerAlert',
  NotificationId: 'AddPaymentInstrument',
  NotificationMessage: 'You need a primary payment method before your ads will run. <a href="mock_url">Add a payment method now</a>',
  NotificationLevel: 'danger',
  ActionTriggered: false,
};
